<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container
        v-if="!loading && items.length"
        class="pt-10 pt-md-13 pt-lg-16"
      >
        <TitleWidget class="text-center">Qual seu Negócio</TitleWidget>

        <v-row class="mt-8" justify="center">
          <template v-for="(item, keyItems) in items">
            <v-col :key="keyItems" cols="6" md="3">
              <BusinessCard v-bind="item" />
            </v-col>
          </template>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import BusinessCard from "../cards/BusinessCard.vue";

const _config = {
  mod: "business",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    BusinessCard,
  },
};
</script>
